import modalStyle from '@/components/Shares/Modal.module.css';
import { Flex, Modal } from '@mantine/core';
import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { DetailCard } from './DetailCard';
import { detail } from './detail';
export const TransactionDetailModal: React.FC = () => {
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  return <Modal opened={openModal === MODAL.TRANSACTION_DETAIL} onClose={() => setOpenModal(null)} closeButtonProps={{
    size: 37,
    bg: 'transparent',
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} overlayProps={{
    bg: 'rgba(23, 26, 30, 0.95)'
  }} size="100%" classNames={modalStyle}>
      <Flex justify="center" w="100%">
        <Flex align="center" miw={{
        base: '100%',
        sm: 648,
        md: 650
      }}>
          <DetailCard coinImg={detail.coinImage} coinValue={detail.coinValue} status={detail.status} txID={detail.txID} orderID={detail.orderID} time={detail.time} />
        </Flex>
      </Flex>
    </Modal>;
};